var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankUserGreen = function SvgBankUserGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "bank-user--green_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bank-user--green_svg__st0{fill:#03d47c}.bank-user--green_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.bank-user--green_svg__st3{fill:#0b1b34}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4 26.3H18.5l21-14.6 21.9 14.6z",
    className: "bank-user--green_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 11c.3-.2.6-.2.9 0l21.8 14.6c.3.2.4.6.3.9-.1.3-.4.6-.8.6H18.5c-.3 0-.7-.2-.8-.6-.1-.3 0-.7.3-.9L39.1 11zm.4 1.6L21 25.5h37.7L39.5 12.6z",
    className: "bank-user--green_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 26.2H29.4L39.8 19l10.7 7.2z",
    className: "bank-user--green_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 18.4c.3-.2.6-.2.9 0l10.7 7.1c.3.2.4.6.3.9-.1.3-.4.6-.8.6h-21c-.4 0-.7-.2-.8-.6-.1-.3 0-.7.3-.9l10.4-7.1zm.5 1.6L32 25.4h15.9L39.8 20z",
    className: "bank-user--green_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6 29.1H21.4v26.6h37.3V29.1z",
    className: "bank-user--green_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 29.1c0-.4.4-.8.8-.8h37.3c.4 0 .8.4.8.8v26.6c0 .4-.4.8-.8.8H21.4c-.4 0-.8-.4-.8-.8V29.1zm1.6.8v25h35.7v-25H22.2z",
    style: {
      fill: "#03d47c",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 55.2H17.7v5.1h44.6v-5.1z",
    className: "bank-user--green_svg__st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 55.2c0-.4.4-.8.8-.8h44.6c.4 0 .8.4.8.8v5.1c0 .4-.4.8-.8.8H17.7c-.4 0-.8-.4-.8-.8v-5.1zm1.6.8v3.5h43V56h-43z",
    className: "bank-user--green_svg__st1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 26.3H17.7v5.1h44.6v-5.1z",
    className: "bank-user--green_svg__st0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 26.3c0-.4.4-.8.8-.8h44.6c.4 0 .8.4.8.8v5.1c0 .4-.4.8-.8.8H17.7c-.4 0-.8-.4-.8-.8v-5.1zm1.6.8v3.5h43v-3.5h-43z",
    className: "bank-user--green_svg__st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 34.8v-3.4h-6.9v3.4h1.4v16.6h-1.4v3.4h7v-3.4h-1.5V34.8h1.4z",
    className: "bank-user--green_svg__st0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 31.4c0-.4.4-.8.8-.8h7c.4 0 .8.4.8.8v3.4c0 .4-.4.8-.8.8H25v15h.7c.4 0 .8.4.8.8v3.4c0 .4-.4.8-.8.8h-7c-.4 0-.8-.4-.8-.8v-3.4c0-.4.4-.8.8-.8h.6v-15h-.6c-.4 0-.8-.4-.8-.8v-3.4zm1.6 2.6h.6c.4 0 .8.4.8.8v16.6c0 .4-.4.8-.8.8h-.6V54h5.4v-1.8h-.7c-.4 0-.8-.4-.8-.8V34.8c0-.4.4-.8.8-.8h.7v-1.8h-5.4V34z",
    className: "bank-user--green_svg__st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 34.8v-3.4H36.6v3.4H38v16.6h-1.4v3.4h6.9v-3.4H42V34.8h1.4z",
    className: "bank-user--green_svg__st0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8 31.4c0-.4.4-.8.8-.8h6.9c.4 0 .8.4.8.8v3.4c0 .4-.4.8-.8.8h-.6v15h.6c.4 0 .8.4.8.8v3.4c0 .4-.4.8-.8.8h-6.9c-.4 0-.8-.4-.8-.8v-3.4c0-.4.4-.8.8-.8h.6v-15h-.6c-.4 0-.8-.4-.8-.8v-3.4zm1.6 2.6h.6c.4 0 .8.4.8.8v16.6c0 .4-.4.8-.8.8h-.6V54h5.3v-1.8H42c-.4 0-.8-.4-.8-.8V34.8c0-.4.4-.8.8-.8h.6v-1.8h-5.3V34z",
    className: "bank-user--green_svg__st1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61 34.8v-3.4h-6.9v3.4h1.5v16.6h4V34.8H61z",
    className: "bank-user--green_svg__st0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3 31.4c0-.4.4-.8.8-.8h7c.4 0 .8.4.8.8v3.4c0 .4-.4.8-.8.8h-.6v15.8c0 .4-.4.8-.8.8h-4c-.4 0-.8-.4-.8-.8V35.6h-.7c-.4 0-.8-.4-.8-.8v-3.4zm1.6 2.6h.7c.4 0 .8.4.8.8v15.8h2.4V34.8c0-.4.4-.8.8-.8h.6v-1.8h-5.4V34z",
    className: "bank-user--green_svg__st1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 54c2.1 0 3.8-1.7 3.8-3.8s-1.7-3.8-3.8-3.8c-2.1 0-3.8 1.7-3.8 3.8s1.7 3.8 3.8 3.8z",
    className: "bank-user--green_svg__st3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 47.3c-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3 1.6 0 3-1.3 3-3s-1.3-3-3-3zm-4.5 2.9c0-2.5 2-4.6 4.6-4.6 2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.6 4.6-2.6 0-4.6-2-4.6-4.6z",
    className: "bank-user--green_svg__st1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 55.2c-4.2 0-7.5 3.4-7.5 7.5 0 .7.6 1.3 1.3 1.3h12.6c.7 0 1.3-.6 1.3-1.3-.2-4.1-3.6-7.5-7.7-7.5z",
    className: "bank-user--green_svg__st3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50 62.7c0-4.6 3.7-8.3 8.3-8.3 4.5 0 8.2 3.7 8.4 8.3 0 1.2-.9 2.1-2.1 2.1H52.1c-1.2 0-2.1-.9-2.1-2.1zm8.3-6.7c-3.7 0-6.7 3-6.7 6.7 0 .3.2.5.5.5h12.6c.3 0 .5-.2.5-.5C65 59 61.9 56 58.3 56z",
    className: "bank-user--green_svg__st1"
  })));
};
export default SvgBankUserGreen;